import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MenuSuperiorComponent } from './menu-superior.component';
import { IonicModule } from '@ionic/angular';
import { MaterialModule } from '../material.module';
import { DirectivesModule } from '../directives/directives.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    MaterialModule,
    DirectivesModule,
    FontAwesomeModule,
  ], exports: [
    MenuSuperiorComponent
  ],
  declarations: [MenuSuperiorComponent]
})
export class MenuSuperiorModule { }